<div class="not-found-page container-fluid">
  <div class="text-center content p-5">
    <h1 class="text-muted">Ha ocurrido un error</h1>
    <button mat-raised-button color="primary" class="action-button" (click)="tryAgain()">Volver a intentarlo</button>
  </div>
</div>
